module.exports = __webpack_public_path__ + "static/media/publishedThanks.e8c23d81.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/habitans/publishedThanks.png
// module id = 1180
// module chunks = 0